<template>
    <b-card class="h-100">
        <h6 v-if="!embedded" class="font-weight-bold mb-3">{{ title }}</h6>
        <div v-if="loading" class="text-center py-5">
            <b-spinner small type="grow"></b-spinner>
        </div>
        <div v-else-if="!hasData" class="text-muted text-center py-5 small">No data available.</div>
        <div v-else class="dashboard-chart-wrap">
            <doughnut-chart-base
                :key="chartRenderKey"
                :chart-data="chartData"
                :options="chartOptions"
            />
        </div>
    </b-card>
</template>

<script>
import DoughnutChartBase from './charts/DoughnutChartBase.vue'

const COLORS = [
    '#007bff',
    '#28a745',
    '#ffc107',
    '#17a2b8',
    '#dc3545',
    '#6f42c1',
    '#fd7e14',
    '#20c997',
    '#6c757d',
    '#e83e8c',
]

export default {
    name: 'SalesRepPieChart',
    components: { DoughnutChartBase },
    props: {
        title: { type: String, required: true },
        data: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
        embedded: { type: Boolean, default: false },
    },
    computed: {
        hasData() {
            return this.data.some((row) => Number(row.value) > 0)
        },
        chartRenderKey() {
            return this.title + '-' + this.data.map((row) => row.label + ':' + row.value).join('|')
        },
        chartData() {
            return {
                labels: this.data.map((row) => row.label),
                datasets: [{
                    backgroundColor: this.data.map((_, index) => COLORS[index % COLORS.length]),
                    data: this.data.map((row) => Number(row.value) || 0),
                }],
            }
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                layout: { padding: { bottom: 4 } },
                legend: {
                    position: 'bottom',
                    labels: { boxWidth: 12, padding: 12 },
                },
                tooltips: {
                    callbacks: {
                        label(tooltipItem, data) {
                            const label = data.labels[tooltipItem.index] || ''
                            const value = data.datasets[0].data[tooltipItem.index] || 0
                            return label + ': $' + Number(value).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })
                        },
                    },
                },
            }
        },
    },
}
</script>

<style scoped>
.dashboard-chart-wrap {
    height: 280px;
    position: relative;
}
.dashboard-chart-wrap ::v-deep > div {
    height: 100% !important;
}
</style>
